import React from 'react';
import { problems } from '../data/content';
export function ProblemSection() {
  return <section className="w-full bg-ink py-14 text-cream sm:py-16 lg:py-20" aria-labelledby="problema" data-id="element-130" data-mp="2lstl5l3i8ih6">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-131" data-mp="30hps1ettrpg7">
        <h2 id="problema" className="max-w-3xl font-display text-3xl font-extrabold leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl" data-id="element-132" data-mp="30jaias93wm89">
          Trabajás igual. Comprás casi lo mismo.{' '}
          <span className="text-amarillo" data-id="element-133" data-mp="35gkin2y1aiav">Pero cada mes alcanza para menos.</span>
        </h2>
        <p className="mt-4 max-w-2xl text-lg leading-relaxed text-cream/70" data-id="element-134" data-mp="3jg1y2rpfwj7k">
          Si algo de esto te pasa todas las semanas, no es que estés haciendo las cosas mal. Es que
          estás comprando sin un sistema.
        </p>

        <ul className="mt-8 grid grid-cols-1 gap-px overflow-hidden rounded-2xl bg-cream/15 sm:grid-cols-2 lg:grid-cols-4" data-id="element-135" data-mp="1p33sumilkcr3">
          {problems.map(p => <li key={p.title} className="flex flex-col bg-ink p-5 sm:p-6" data-id="element-136" data-mp="jd3nknzxobrf">
              <h3 className="font-display text-lg font-bold leading-snug text-cream" data-id="element-137" data-mp="jey6jwrn9tsv">{p.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-cream/65" data-id="element-138" data-mp="ocgbzd6gdqw4">{p.text}</p>
            </li>)}
        </ul>

        <p className="mt-8 max-w-3xl border-l-4 border-amarillo pl-5 font-display text-xl font-bold leading-snug sm:text-2xl" data-id="element-139" data-mp="x4i9p3p50t2p">
          El problema no siempre es cuánto comprás. Muchas veces es cómo, cuándo y con qué pagás.
        </p>
      </div>
    </section>;
}